//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mixins from './mixins'
import Question from './_question'
import Result from './_result'
import { getQuestions, getPoints, setAnsweredQuestions } from './const'
const STATUS = {
    DOING: 'doing',
    DONE: 'done'
}
export default {
    mixins: [mixins],
    components: {
        Question,
        Result
    },
    data () {
        const questions = getQuestions()
        return {
            status: STATUS.DOING,
            questions,
            current: 0,
            result: '',
            current_question: questions[0],
            answered_questions: [],
            is_sub_question: false,
            total_points: 0
        }
    },
    computed: {
        has_sub_question () {
            return this.current_question && this.current_question.answers && this.current_question.answers.some((item) => {
                return item.checked && item.sub_question
            })
        }
    },
    methods: {
        prev () {
            if (!this.is_sub_question) {
                --this.current
            }
            this.current_question = this.answered_questions.splice(this.answered_questions.length - 1, 1)[0]
        },
        next () {
            this.is_sub_question = false
            this.answered_questions.push(this.current_question)
            if (this.current === this.questions.length - 1 || this.result) {
                this.status = STATUS.DONE
                this.total_points = getPoints(this.answered_questions)
            } else {
                if (!this.has_sub_question) {
                    ++this.current
                    this.current_question = this.questions[this.current]
                } else {
                    const { answers } = this.current_question
                    for (let i = 0; i < answers.length; i++) {
                        const item = answers[i]
                        if (item.checked && item.sub_question) {
                            this.current_question = {
                                title: this.current_question.title,
                                ...item.sub_question
                            }
                            this.is_sub_question = true
                            break
                        }
                    }
                }
            }
        },
        changeRadio (value) {
            const [i, j] = value.split('-')
            const { items } = this.current_question
            items.forEach(({ answers }, q_index) => {
                answers.forEach((item, a_index) => {
                    item.checked = q_index === Number(i) && a_index === Number(j)
                })
            })
        },
        changeMultiRadio (value) {
            const [i, j] = value.split('-')
            const { items } = this.current_question
            const { answers } = items[i]
            answers.forEach((item, index) => {
                item.checked = index === Number(j)
            })
        },
        change (index) {
            const { answers, range } = this.current_question
            this.result = ''
            if (this.current_question.checkbox) {
                const answer = answers[index]
                const { singled } = answer
                answers.forEach((item) => {
                    if (singled) {
                        item.checked = false
                    } else if (item.singled) {
                        item.checked = false
                    }
                })
                answer.checked = !answer.checked
            } else if (this.current_question.select) {
                this.current_question.selected = index
            } else {
                answers.forEach((answer, i) => {
                    answer.checked = index === i
                    if (answer.checked && answer.result) {
                        this.result = answer.result
                    }
                })
            }
        },
        changeInputs (i, j, value) {
            console.log(i, j, value)
            const { items } = this.current_question
            const { inputs } = items[i]
            inputs[j].value = value
        },
        changeInput (index, val) {
            const { answers } = this.current_question
            answers[index].input_val = val
        },
        openDetail () {
            setAnsweredQuestions(this.answered_questions)
            wx.navigateTo({
                url: '/pages/packageA/residence_points/result'
            })
        }
    }
}
